export default {
  large: `(min-width: 1080px)`,
  medium: `(max-width: 1080px)`,
  small: `(max-width: 650px)`,
};
